import { FC } from 'react';

import { VoidFn } from 'types/baseTypes';

interface MoreMenuItem {
  id: string;
  icon: JSX.Element;
  text: string;
  onClick: VoidFn;
}

interface MoreMenuProps {
  menuItems: MoreMenuItem[];
}

const MoreMenu: FC<MoreMenuProps> = props => {
  const { menuItems } = props;

  return (
    <div className="flex flex-col space-y-4 text-sbase font-semibold text-primaryText">
      {menuItems.map(menu => (
        <div onClick={menu.onClick} className={'flex flex-row items-center gap-2'} key={menu.id}>
          {menu.icon}
          <div>{menu.text}</div>
        </div>
      ))}
    </div>
  );
};

export default MoreMenu;
